import { formatCurrency, formatNumber, formatPercent } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { parseFloatSafe } from '../func';

@Pipe({
  name: 'formatCurrency'
})
export class FormatCurrencyPipe implements PipeTransform {

  transform(value: number | string): string
  transform(value: number | string | undefined): string | undefined
  transform(value: number | string | null | undefined): string | null | undefined {
    return value !== null && value !== undefined ? formatCurrency(parseFloatSafe(value), 'en', '$', 'USD', '1.0-2') : value
  }

}

@Pipe({
  name: 'formatPrice'
})
export class FormatPricePipe implements PipeTransform {

  transform(value: number | string): string
  transform(value: number | string | undefined): string | undefined
  transform(value: number | string | null | undefined): string | null | undefined {
    return value !== null && value !== undefined ? formatCurrency(parseFloatSafe(value), 'en', '$', 'USD', '1.0-16') : value
  }

}

@Pipe({
  name: 'formatQuantity'
})
export class FormatQuantityPipe implements PipeTransform {

  transform(value: number | string): string
  transform(value: number | string | undefined): string | undefined
  transform(value: number | string | null | undefined): string | null | undefined {
    return value !== null && value !== undefined ? formatNumber(parseFloatSafe(value), 'en', '1.0-16') : value
  }

}

@Pipe({
  name: 'formatPercent'
})
export class FormatPercentPipe implements PipeTransform {

  transform(value: number | string, decimals: number): string
  transform(value: number | string | undefined, decimals: number): string | undefined
  transform(value: number | string | null | undefined, decimals = 2): string | null | undefined {
    return value !== null && value !== undefined ? formatPercent(parseFloatSafe(value), 'en', `1.0-${decimals}`) : value
  }

}

@Pipe({
  name: 'formatNumber'
})
export class FormatNumberPipe implements PipeTransform {

  transform(value: number | string, decimals: number): string
  transform(value: number | string | undefined, decimals: number): string | undefined
  transform(value: number | string | null | undefined, decimals = 2): string | null | undefined {
    return value !== null && value !== undefined ? formatNumber(parseFloatSafe(value), 'en', `1.0-${decimals}`) : value
  }

}

@Pipe({
  name: 'asFloat'
})
export class AsFloatPipe implements PipeTransform {

  transform(value: number | string): number
  transform(value: number | string | undefined): number | undefined
  transform(value: number | string | null | undefined): number | null | undefined {
    return value !== null && value !== undefined ? parseFloatSafe(value) : value
  }

}
